import { useSelector } from 'react-redux';

/**
 * Dark mode follows Redux appSettings (same source as theme panel).
 * @returns {boolean} isDarkMode
 */
const useDarkMode = () => {
  return Boolean(useSelector((state) => state.appSettings?.appDarkMode));
};

export default useDarkMode;
